import React from 'react'
import { MFEComponent } from '@kohls/web-shop-ui-astro-shared/src/components/MFEComponent'

type RegistryListWrapperProps = {
  manifest?: any
  id?: string
}

export const RegistryListWrapper = ({ manifest, id }: RegistryListWrapperProps): JSX.Element => {
  return (
    <React.Fragment>
      <div style={{ width: '100%', minHeight: '500px' }}>
        <MFEComponent
          manifest={manifest.mfe_registry}
          componentName="RegistryList"
          maxWidth="100%"
          height="500px"
          componentProps={{
            id: id,
            renderShippingAddress: (props: any) => (
              <>
                <MFEComponent manifest={manifest.mfe_account} componentName="ShippingAddressForm" maxWidth="100%" height="500px" componentProps={props} />
              </>
            ),
          }}
        />
      </div>
    </React.Fragment>
  )
}
